import * as yup from 'yup';
import type { Articulo, Inventario } from '../../stores/articulos/articulo';
import type { AgrupacionArticulos } from '../../stores/agrupaciones-articulos/agrupacion-articulos';

export const validationSchema = yup.object<Articulo>({
  id: yup.string().required('El código es requerido'),
  descripcion: yup.string().uppercase().required('La descripción es requerida'),
  idClasificacion: yup.number().moreThan(0, 'La clasificación es requerida'),
  agrupaciones: yup
    .array()
    .min(1, 'Debe proporcionar al menos un grupo / agrupación')
    .test({
      name: 'no-repetidos',
      message: 'El grupo ya está asignado al artículo',
      test: (value: any[] | undefined) =>
        new Set(value?.map((x) => x.idGrupo)).size === value?.length
    }),
  equivalencias: yup
    .array()
    .min(1, 'El artículo debe tener al menos una equivalencia como unidad base, equivalencia = 1')
    .test({
      name: 'es-base',
      message:
        'El artículo debe tener al menos una equivalencia como unidad base, equivalencia = 1',
      test: (values: any[] | undefined) => values?.some((x) => x.cantidad === 1) ?? false
    })
    .test({
      name: 'solo-1-base',
      message: 'El artículo debe tener solo una equivalencia como unidad base, equivalencia = 1',
      test: (values: any[] | undefined) =>
        values?.filter((x) => x.cantidad === 1)?.length === 1 || false
    }),
  inventario: yup
    .array()
    .min(1, 'Debe proporcionar al menos un almacén en el inventario')
    .test({
      name: 'ubicacion-requerida',
      message: 'Debe seleccionar una ubicación para cada almacén en el inventario',
      test: (value: any[] | undefined) =>
        value?.every((x) => x.idUbicacion) || false
    })
});

export interface ArticuloFormValues {
  id: string;
  descripcion: string;
  idClasificacion: number;
  agrupaciones: Array<AgrupacionArticulos>;
  equivalencias: Array<{
    id?: string;
    idUnidad: string;
    cantidad: number;
  }>;
  inventario: Array<Inventario>;
}
